

export class TyreBrandOutputWithStatus implements ITyreBrandOutputWithStatus {
    /** The auto-generated id of the tyre brand master */
    tyre_brand_id!: number;
    /** The tyre brand name with 255 character limit */
    tyre_brand_name!: string;
    /** Manage status of country. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: ITyreBrandOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tyre_brand_id = _data["tyre_brand_id"];
            this.tyre_brand_name = _data["tyre_brand_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TyreBrandOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TyreBrandOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tyre_brand_id"] = this.tyre_brand_id;
        data["tyre_brand_name"] = this.tyre_brand_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITyreBrandOutputWithStatus {
    /** The auto-generated id of the tyre brand master */
    tyre_brand_id: number;
    /** The tyre brand name with 255 character limit */
    tyre_brand_name: string;
    /** Manage status of country. 0 For De-active, 1 For Active */
    status: number;
}

